module.exports = __webpack_public_path__ + "img/4.f446e4ce.jpg";